module.exports = __webpack_public_path__ + "resources/d444a1ba06427b10a3f9ec62c288dab5.png";